module.exports = __webpack_public_path__ + "fonts/DINPro-LightItalic.f51d93b3.otf";